import {createEntityAdapter} from '@reduxjs/toolkit';

/**
 * Crud adapter for rate bands. Sorts rate bands by duration as a default
 * @see https://redux-toolkit.js.org/api/createEntityAdapter
 */
export const rateBandsEntityAdapter = createEntityAdapter({
    selectId: (rateBand) => rateBand.duration,
    sortComparer: (a, b) =>
        a.duration.localeCompare(b.duration, 'en-u-kn-true'),
});

/**
 * Crud adapter for rate segments. Sorts rate segments by id as a default
 * @see https://redux-toolkit.js.org/api/createEntityAdapter
 */
export const rateSegmentsEntityAdapter = createEntityAdapter({
    selectId: (rateSegment) => rateSegment.customRateId,
    sortComparer: (a, b) => a.customRateId - b.customRateId,
});

/**
 * Crud adapter for multi-day discounts. Sorts multi-day discounts by duration as a default
 * @see https://redux-toolkit.js.org/api/createEntityAdapter
 */
export const multiDayDiscountsEntityAdapter = createEntityAdapter({
    selectId: (discount) => discount.duration,
    sortComparer: (a, b) =>
        a.duration.localeCompare(b.duration, 'en-u-kn-true'),
});
